module.exports = __webpack_public_path__ + "img/efa95de713f8fa8108bb534c0114a6fd.f9b608d7.jpg";